import { createRouter, createWebHistory } from 'vue-router';
import RenderPage from "@/views/painel/render/RenderPage.vue";
import sessionGuardian from "@/services/session.guardian";

const routes = [
  // --------- ROTAS PÚBLICAS ---------
  { path: '/pages/:id',            name: 'render-pt',   component: RenderPage },
  { path: '/en/pages/:id',         name: 'render-en',   component: RenderPage, props: { lang: 'en' } },

  { path: '/search',               name: 'SearchResults', component: () => import('@/views/sitegame/SearchResults.vue') },
  { path: '/home',                 name: 'home',        component: () => import('@/views/sitegame/HomeView.vue') },
  { path: '/en/home',              name: 'home-en',     component: () => import('@/views/sitegame/HomeView.vue'), props: { lang: 'en' } },
  { path: '/notfound',             name: 'NotFound',    component: () => import('@/views/NotFound.vue') },
  { path: '/login',                name: 'login',       component: () => import('@/views/painel/LoginView.vue') },
  { path: '/politicadeprivacidade',                    component: () => import('@/views/sitegame/page-games/PolíticaPrivacidade.vue') },
  { path: '/deletarconta',                               component: () => import('@/views/sitegame/page-games/DeletarConta.vue') },

  // --------- ROTAS GAMIFICAÇÃO ---------
  { path: '/gamificacao/home',     name: 'gamificacao-home',    component: () => import('@/views/sitegamificacao/home/HomeView.vue') },
  { path: '/gamificacao/news',     name: 'gamificacao-news',    component: () => import('@/views/sitegamificacao/news/NewsPage.vue') },
  { path: '/gamificacao/contact',  name: 'gamificacao-contact', component: () => import('@/views/sitegamificacao/ContactView.vue') },
  { path: '/gamificacao/projects', name: 'gamificacao-projects',component: () => import('@/views/sitegamificacao/ProjectsPage.vue') },

  // --------- NOVO PAINEL ADMIN (WOW UX/UI) ---------
  { path: '/admin/login',          name: 'AdminLogin',          component: () => import('@/views/admin/LoginView.vue') },
  { 
    path: '/admin', 
    component: () => import('@/views/admin/layout/AdminLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      { path: '', redirect: '/admin/dashboard' },
      { path: 'dashboard',         name: 'AdminDashboard',      component: () => import('@/views/admin/DashboardView.vue') },
      { path: 'home-edit',         name: 'AdminHomeEdit',       component: () => import('@/views/painel/entreterimento/HomeEdit.vue') },
      { path: 'gamificacao-home-edit', name: 'AdminGamificacaoHomeEdit', component: () => import('@/views/admin/GamificacaoHomeEdit.vue') },
      { path: 'newsletter',        name: 'AdminNewsletter',     component: () => import('@/views/admin/NewsletterView.vue') },
      { path: 'contacts',          name: 'AdminContacts',       component: () => import('@/views/admin/ContactsView.vue') },
      { path: 'users',             name: 'AdminUsers',          component: () => import('@/views/admin/UsersView.vue') },
      { path: 'pages',             name: 'AdminPages',          component: () => import('@/views/admin/PagesView.vue') },
      { path: 'pages/new',         name: 'AdminPageCreate',     component: () => import('@/views/admin/PageEditorView.vue') },
      { path: 'pages/edit/:id',    name: 'AdminPageEdit',       component: () => import('@/views/admin/PageEditorView.vue') },
    ]
  },

  // --------- ROTAS PAINEL/ADMIN ANTIGO (MANTIDAS) ---------
  { path: '/painel',               name: 'painel',              component: () => import('@/views/painel/PainelView.vue'), meta: { requiresAuth: true } },
  { path: '/dashboard-analytics',  name: 'DashboardAnalytics',  component: () => import('@/views/painel/DashboardAnalytics.vue'), meta: { requiresAuth: true } },
  { path: '/newsletter-list',      name: 'NewsletterList',      component: () => import('@/views/painel/NewsletterList.vue'), meta: { requiresAuth: true } },
  { path: '/contacts-list',        name: 'ContactList',         component: () => import('@/views/painel/ContactList.vue'), meta: { requiresAuth: true } },
  { path: '/home-edit',            name: 'HomeEdit',            component: () => import('@/views/painel/HomeEditView.vue'), meta: { requiresAuth: true } },
  { path: '/projectcreate/:id',    name: 'ProjectCreate',       component: () => import('@/views/painel/ProjectsView.vue'), meta: { requiresAuth: true } },
  { path: '/gamecreate',           name: 'GameCreate',          component: () => import('@/views/painel/GamesView.vue'), meta: { requiresAuth: true } },
  { path: '/blogcreate',           name: 'BlogCreate',          component: () => import('@/views/painel/PagesView.vue'), meta: { requiresAuth: true } },
  { path: '/home-edit-new',        name: 'HomeEditNew',         component: () => import('@/views/painel/entreterimento/HomeEdit.vue'), meta: { requiresAuth: true } },

  { path: '/',                     redirect: '/home' },

  { path: '/:pathMatch(.*)*',      name: 'NotFoundCatch',       component: () => import('@/views/NotFound.vue') }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth'
      };
    }
    if (savedPosition) {
      return savedPosition;
    }
    return { top: 0 };
  }
});

router.beforeEach((to, from, next) => {
  const isLoggedIn = !!sessionGuardian?.getToken?.();
  if (to.meta.requiresAuth && !isLoggedIn) {
    if (to.path.startsWith('/admin')) {
      next({ path: '/admin/login', query: { redirect: to.fullPath } });
    } else {
      next({ path: '/login', query: { redirect: to.fullPath } });
    }
  } else {
    next();
  }
});

export default router;
